import React, { useEffect } from 'react';
import { Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { normalizeTelegramJoinLink } from '../../../domain/entities/TelegramMessenger';

interface MessengerJoinLinkModalProps {
  open: boolean;
  isJoining: boolean;
  onCancel: () => void;
  onSubmit: (link: string) => Promise<void>;
}

interface MessengerJoinLinkFormValues {
  link: string;
}

const MessengerJoinLinkModal: React.FC<MessengerJoinLinkModalProps> = ({ open, isJoining, onCancel, onSubmit }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<MessengerJoinLinkFormValues>();

  useEffect(() => {
    if (open) form.resetFields();
  }, [open, form]);

  const validateLink = async (_: unknown, value?: string) => {
    try {
      normalizeTelegramJoinLink(value ?? '');
    } catch (e) {
      throw new Error(t(e instanceof Error ? e.message : 'unknown-error', { ns: 'errors' }));
    }
  };

  return (
    <Modal
      open={open}
      title={t('messenger-join-by-link', { ns: 'titles' })}
      okText={t('messenger-join', { ns: 'buttons' })}
      cancelText={t('cancel', { ns: 'buttons' })}
      confirmLoading={isJoining}
      onCancel={onCancel}
      onOk={() => form.submit()}
      destroyOnClose
    >
      <Form form={form} layout="vertical" requiredMark={false} onFinish={(values) => onSubmit(values.link.trim())}>
        <Form.Item name="link" label={t('messenger-join-link', { ns: 'labels' })} rules={[{ validator: validateLink }]}>
          <Input placeholder={t('messenger-join-link-placeholder', { ns: 'labels' })} autoFocus />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default MessengerJoinLinkModal;
